import React, { createRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import { classNames, Constants, formatMiles, fromPhotos, Globals } from '../../../utils';
import { AuthService, ProductsService } from '../../../services';
import { ChevronRightIcon, ListIcon } from '../../../assets/icons';
import { HomeBanner, Logo } from '../../../assets/img';

const getMinPrice = (item) => {
  if (item.is_deductible_based) {
    const minDeductibles = item?.deductibles?.map(d => {
      const notEmptyOrDisabled = d.premiums.filter(p => !p.is_disabled && (p.price_monthly > 0 || p.price_annual > 0));
      const minPremium = notEmptyOrDisabled?.map(p => {
        return parseFloat(parseFloat(p.price_monthly) > 0 ? p.price_monthly : p.price_annual);
      });
      return Math.min(...minPremium);
    });
    return Math.min(...minDeductibles);

  } else {
    return Math.min(...item?.prices?.map(x => parseFloat(parseFloat(x.price_monthly) > 0 ? x.price_monthly : x.price_annual)));
  }
};

class Home extends React.Component {

  state = {
    page: 1,
    pages: 1,
    supportComment: '',
    products: [],
    payment_pending_vehicle_data: null
  }

  supportModalRef = createRef();
  subscriber = null;

  componentDidMount() {
    this.getProducts();
    this.checkReferralCode();
  }

  getProducts = async (page = 1) => {
    try {
      const res = await ProductsService.getProducts({ page });
      this.setState({
        products: page > 1 ? [ ...this.state.products, ...res.data ] : res.data,
        page,
        pages: res.pages,
        payment_pending_vehicle_data: res.payment_pending_vehicle_data || null
      });

    } catch (error) {
      console.log(error);
    }
  }

  checkReferralCode = async () => {
    const referral_code = this.props.referral_code;
    if (!referral_code) return;

    try {
      // Se envía la solicitud para el cambio de referido
      AuthService.updateReferral({ referral_code })
        .then(user => {
          if (!user.result) return toast.error('El código ya no está disponible');
          toast.success('Referido actualizado correctamente');
          this.props.dispatch({ type: 'SET_USER', payload: user.user });
          setTimeout(() => {
            this.props.history.replace('/');
            window.location.reload();
          }, 2000);
        })
        .catch(console.log)
        .finally(() => this.props.dispatch({ type: 'SET_REFERRAL_CODE', payload: null }));

    } catch (error) {
      console.log(error)
    }
  }

  toggleSupportModal = () => {
    if (!!this.supportModalRef.current.open) {
      this.supportModalRef.current.close();
      this.setState({ supportComment: '' });
    } else {
      this.supportModalRef.current.showModal();
    }
  }

  sendSupportComment = async () => {
    if (!this.state.supportComment)
      return toast.error('Debe indicar la incidencia');

    try {
      await AuthService.sendSupportComment({ comment: this.state.supportComment });
      this.toggleSupportModal();
      toast.success('Incidencia enviada');

    } catch (error) {
      console.log(error);
    }
  }

  goToCompleteData = () => {
    this.props.history.push({
      pathname: '/historial/pagos/completar',
      state: {
        item: this.state.payment_pending_vehicle_data
      }
    });
  }

  render() {
    return (
      <>
        <dialog ref={this.supportModalRef} className="fixed inset-0 z-50 overflow-y-auto bg-transparent">
          <div className="max-w-96 bg-white px-6 py-4 rounded-xl">
            <h1 className="font-semibold text-lg text-blue">
              Reporte de incidencia
            </h1>
            <p className="mt-2 text-sm">En caso de presentar un inconveniente o alguna duda debe comunicarse al</p>
            <p className="mb-5 text-sm font-semibold">soporteapp@proseguros.com.ve</p>

            <textarea
              className="w-full px-2 py-1 outline-none rounded-md border border-gray6 align-top"
              placeholder="Indique la incidencia"
              rows={4}
              value={this.state.supportComment}
              onChange={e => this.setState({ supportComment: e.target.value })}
            />

            <div className="flex w-full justify-around items-center mt-5">
              <button onClick={this.toggleSupportModal}>
                <span className="font-semibold">Cancelar</span>
              </button>
              <button onClick={this.sendSupportComment}>
                <span className="font-semibold">Enviar</span>
              </button>
            </div>
          </div>
        </dialog>

        <div className="p-1 sm:p-4 pt-1 mt-8 lg:mt-0">
          <div>
            <div className="bg-darkBlue flex flex-col rounded-3xl relative overflow-hidden">
              {/* <img src={HomeLogo} className="w-40 object-contain" alt="" />
              <div className="flex justify-between">
                <div className="flex justify-end pb-5 gap-3 mt-4">
                  <span className="text-3xl font-semibold text-white">
                    { this.props.user?.gender_id === Constants.GENDER.MALE ? 'Bienvenido' : 'Bienvenida' }
                  </span>
                  <span className="text-3xl font-semibold text-white">
                    { this.props.user?.name }
                  </span>
                </div>
              </div> */}
              <div className="w-full">
                <img src={HomeBanner} className="object-contain w-full" alt="" />
              </div>
            </div>

            {
              this.state.payment_pending_vehicle_data != null && (
                <button
                  className="bg-yellow rounded-xl mt-3 py-2 px-2 font-semibold text-black flex items-center"
                  onClick={() => this.goToCompleteData()}
                >
                  <div className="bg-green rounded-xl w-8 h-8 flex justify-center items-center">
                    <img src={ ListIcon } className="w-6 h-6 object-contain" alt="" />
                  </div>
                  <span className="ml-2">Completa los datos para activar tu RCV</span>
                </button>
              )
            }

            <div className="flex flex-1 justify-between items-center rounded-tl-5 rounded-tr-5">
              <div className="flex items-center py-4 gap-2">
                <span className="text-2xl font-bold text-black">
                  { this.props.user?.gender_id === Constants.GENDER.MALE ? 'Bienvenido' : 'Bienvenida' }
                </span>
                <span className="text-2xl font-semibold text-black">
                  { this.props.user?.name }
                </span>
              </div>

              <img src={Logo} className="w-48 object-contain" alt="" />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
              {this.state.products.map((item, i) => (
                <CardItem key={i} item={item} index={i} />
              ))}
            </div>

            {!this.state.products.length && (
              <p className="text-center mt-5">No hay productos</p>
            )}

            {this.state.products.length > 0 && (
              <p className="my-5 font-semibold text-sm text-gray3 text-center">
                Aprobada por la SUDEASEG bajo el código ES-106
              </p>
            )}
          </div>
        </div>
      </>
    );
  }
}

const CardItem = ({ item }) => {
  const history = useHistory();
  const [showPrices, setShowPrices] = useState(false);
  const minPrice = getMinPrice(item);
  const productId = btoa(btoa(String(item?.id).padStart(5,'0')));

  return (
    <div
      className="cursor-pointer mb-4 relative"
      onClick={() => history.push(`/productos/${productId}`)}
    >
      <div className="rounded-xl overflow-hidden bg-white border border-gray6 h-full flex flex-1">
        <div className="py-1 flex flex-1 flex-col justify-between">
          <p className="font-semibold px-2.5 text-lg text-black line-clamp-3">
            { item.name }
          </p>

          {!!item?.description && (
            <p className="text-xs text-gray my-1 px-2.5 line-clamp-2">
              { item.description }
            </p>
          )}

          <div className="flex items-end justify-between px-2.5 py-1">
            <div className="bg-secondary rounded-xl px-2 text-white">
              <span className="text-md mr-2">Desde</span>
              <span className="text-lg font-bold">
                { formatMiles(minPrice, !Number.isInteger(parseFloat(minPrice))).replace(' ','') }
              </span>
            </div>

            {!!item?.prices?.length && (
              <div
                className="w-6 h-6 rounded-full bg-darkBlue flex justify-between items-center"
                onClick={e => {
                  e.stopPropagation();
                  setShowPrices(!showPrices);
                }}
              >
                <img
                  src={ChevronRightIcon}
                  className={classNames('w-3.5 h-3.5 object-contain flex-1 brightness-0 invert transition-all', showPrices ? '-rotate-90' : 'rotate-90')}
                  alt=""
                />
              </div>
            )}
          </div>

          {showPrices && (
            <div className="absolute bg-slate-100 border border-gray6 translate-y-full z-10 shadow-md bottom-0 w-10/12 rounded-lg">
              {item?.prices?.map((p, priceIdx) => {
                const _minPrice = parseFloat(p.price_monthly) ? p.price_monthly : p.price_annual;
                return (
                  <div key={priceIdx} className="flex flex-1 items-center justify-between px-2.5 pt-1 pb-1 [&:not(:first-child)]:border-t [&:not(:first-child)]:border-t-gray6">
                    <span className="text-xs font-semibold text-gray2">{ p.name }</span>
                    <span className="text-lg font-semibold text-darkBlue text-nowrap">
                      { formatMiles(_minPrice, !Number.isInteger(parseFloat(_minPrice))) }
                    </span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div>
          <img
            src={fromPhotos(item.photo)}
            className="w-40 object-cover aspect-square"
            alt=""
          />
          {!!item?.discount && (
            <span className="absolute bg-red text-white left-0 bottom-0 px-1 py-0.5 text-xs">-25% Por este mes</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default connect(state => ({
  user: state.user,
  referral_code: state.referral_code,
}))(Home);
